import EcsInteraction from '@/components/ecs-interaction/EcsInteraction';

/**
 * ConnectedParty Class.
 *
 * @module ConnectedParty
 **/
export default class ConnectedParty {
  /**
   * @constructor
   * @this {ConnectedParty}
   *
   * @param {Object} rawInfo - Connected party information.
   **/
  constructor({ id, name, contactUri, partyType }) {
    Object.assign(this, ...arguments);
  }

  /**
   * Public getters
   */

  get isAgent() {
    return this.partyType === EcsInteraction.partyType.agent;
  }

  get isCustomer() {
    return this.partyType === EcsInteraction.partyType.customer;
  }
}
